import '|/app.styl';

//Scripts
import OffsetHeight from './OffsetHeight';

(function ($) {

    // This is for everyone
    window.$      = $;
    window.jQuery = jQuery;

    $(document).ready(function () {

        // Run our utility scripts
        new OffsetHeight();
        
    });

})(jQuery);